<template>
  <nv-tab-page>
    <v-data-table :headers="headers" :items="items" :loading="loading">
      <template #item="{ item }">
        <tr>
          <td>{{ item.name }}</td>
          <td>{{ item.id }}</td>
          <td>
            <country-badge
              v-if="item.country_codes && item.country_codes[0]"
              :country="item.country_codes[0]"
            />
            <span v-else>—</span>
          </td>
          <td>{{ item.start_date | date }}</td>
          <td>{{ item.end_date | date }}</td>
        </tr>
      </template>
      <template #no-data>
        <div class="pa-4 text-center">No data available</div>
      </template>
    </v-data-table>
  </nv-tab-page>
</template>

<script>
import HTTP from '@/api/owl';
import CountryBadge from '@/components/CountryBadge';

const headers = [
  { text: 'Name', sortable: false, value: 'name' },
  { text: 'Tree ID', sortable: false, value: 'id' },
  { text: 'Market', sortable: false, value: 'market' },
  { text: 'Start Date', sortable: false, value: 'start_date' },
  { text: 'End Date', sortable: false, value: 'end_date' },
];

const types = ['parents', 'brands', 'channels'];

export default {
  components: { CountryBadge },
  props: {
    type: {
      type: String,
      required: true,
      validator: v => types.indexOf(v) !== -1,
    },
    id: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    headers,
    items: [],
    loading: false,
  }),
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      HTTP.get(`/localization/rules/${this.id}`, { params: { country_code: '*' } })
        .then(({ data }) => {
          this.items = Array.isArray(data) ? data : [];
        })
        .catch(err => {
          this.$flash('error', 'Failed to load localization rules');
          console.error('Localization rules fetch error:', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
